export default {
  setProducts (state, products) {
    state.products = products
  }
}
